import {
    LOGIN,
    LOGOUT,
    SET_AUTH_TOKEN,
    REMOVE_AUTH_TOKEN,
    SET_LOGGED_USER,
    SET_USER_ROLE,
    REMOVE_USER_ROLE
}
    from "../actions/action_types";

const initialState = {
    isUserLoggedIn: false,
    authToken: "",
    user: null,
    userRole: 0
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return { ...state, isUserLoggedIn: true };
        case LOGOUT:
            return { ...state, isUserLoggedIn: false };
        case SET_AUTH_TOKEN:
            return { ...state, authToken: action.authToken };
        case REMOVE_AUTH_TOKEN:
            return { ...state, authToken: "" };
        case SET_LOGGED_USER:
            return { ...state, user: action.user }
        case SET_USER_ROLE:
            return { ...state, userRole: action.role }
        case REMOVE_USER_ROLE:
            return { ...state, userRole: 0 }
        default:
            return state;
    }
};
export default authReducer;
